import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { verify } from "../../services/paymentService";
import { setPaymentLoading } from "../../store/actions";
import { getDossier } from "../../services/dossierService";
import Paragraph from "../atoms/Paragraph";
import Button from "../atoms/Button";
import styled from "styled-components";
import Loader from "../atoms/icons/Loader";
import { withModal } from "../../contexts/ModalContext";
import { openRandomQuestionModal } from "../../services/modalService";
import { bugsnagClient } from "../../services/bugsnag";
import { Trans, useTranslation } from "react-i18next";

const StyledParagraph = styled(Paragraph)`
  margin-bottom: 20px;
`;

const StyledAnchor = styled.a`
  color: ${props => props.theme.tertiary};

  &:hover {
    color: ${props => props.theme.tertiaryHover};
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const VerifyPaymentModal = ({ onRequestClose, showModal, select }) => {
  const { t } = useTranslation(["common", "dossier"]);
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState(null);
  const [status, setStatus] = useState("loading");
  const [type, setType] = useState("loading");
  const { isLoading } = useSelector(state => state.data);

  useEffect(() => {
    window.history.replaceState(null, null, "/");
  }, []);

  const refreshDossier = () => {
    dispatch(setPaymentLoading(true));
    dispatch(getDossier(true)).then(() => {
      dispatch(setPaymentLoading(false));
    });
  };

  useEffect(
    () => {
      if (!isLoading) {
        dispatch(verify())
          .then(res => {
            setStatus(res.status);
            setType(res.type);

            if (res.status === "paid") {
              refreshDossier();
            }
          })
          .catch(() => {
            const newErrorMessage = t(
              "dossier:payment.confirm_payment_status_error"
            );

            setStatus("Unknown");
            setErrorMessage(newErrorMessage);
            bugsnagClient.leaveBreadcrumb(newErrorMessage);
          });
      }
    },
    [isLoading]
  );

  const openQuestionModal = e => {
    e.preventDefault();
    openRandomQuestionModal(showModal);
  };

  if (status === "loading") {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  if (status === "paid") {
    return (
      <>
        <StyledParagraph>{t("dossier:payment.confirm_paid")}</StyledParagraph>
        <Button primary wide onClick={onRequestClose}>
          {t("generic.close")}
        </Button>
      </>
    );
  }

  return (
    <>
      <StyledParagraph>
        {errorMessage
          ? errorMessage
          : t("dossier:payment.confirm_payment_error")}{" "}
        <br />
        <Trans
          i18nKey={"dossier:payment.confirm_contact_us"}
          components={{
            anchor: (
              <StyledAnchor
                href="javascript: void(0);"
                onClick={openQuestionModal}
              />
            ),
          }}
        />
      </StyledParagraph>
      <Button primary wide onClick={onRequestClose}>
        {t("generic.close")}
      </Button>
    </>
  );
};

export default withModal(VerifyPaymentModal);
